import React from 'react';
import { ResidentialLanding } from './components/ResidentialLanding';
export function App() {
  return <ResidentialLanding data-id="element-0" />;
}